import React from 'react';
import loadable from '@loadable/component';
import connectRoute from 'app/routes/connectRoute';
import ShelfActions from 'app/actions/ShelfActions';
import { getRequestedUser } from 'app/selectors/UserSelector';

const PrintShelfContainer = loadable(() => import('app/containers/print/PrintShelfContainer'));

export function PrintShelfPageRoute() {
  return <PrintShelfContainer />;
}

function getRouteData({ dispatch, state, params, query }) {
  const user = getRequestedUser(state);
  const userId = user && user.get('id');

  if (userId && params.shelfName) {
    return [dispatch(ShelfActions.searchUserShelf(params.shelfName, userId, query))];
  }

  return [];
}

export default connectRoute(PrintShelfPageRoute, { getRouteData });
